import { toast } from "react-toastify";
import { apiSlice } from ".";

const TasksApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    postTask: builder.mutation({
      query: (data) => ({
        url: "/TaskTables/PostTaskTable",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Assigning Task",
          success: "Task Has Been Assigned",
          error: "Error Assigning Task",
        });
      },
      invalidatesTags: ["Tasks"], // This triggers automatic refetch of any query using 'Tasks' tag
    }),
    editTask: builder.mutation({
      query: (data) => ({
        url: `/TaskTables/PutTaskTable/${data.taskId}`,
        method: "POST",
        body: data,
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Editing Task",
          success: "Task Has Been Edited",
          error: "Error Editing Task",
        });
      },
      invalidatesTags: ["Tasks"], // This triggers automatic refetch of any query using 'Tasks' tag
    }),

    getAllTasks: builder.query({
      query: ({ senderId, receiverId, agcId, from, to, status }) =>
        `/TaskTables/GetTask?senderid=${senderId}&receiverid=${receiverId}&agcid=${agcId}&fro=${from}&to=${to}&status=${status}`,
      providesTags: ["Tasks"], // This links the query to the 'Tasks' tag
    }),
  }),
});


export const {
usePostTaskMutation,
useGetAllTasksQuery,
useEditTaskMutation
} = TasksApi;
